var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_744_33733)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 49.763,
    cy: 28.373,
    r: 13.3355,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 32.9182,
    cy: 60.659,
    r: 13.3355,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9063 54.7528C80.5841 54.4407 77.7859 57.0382 77.7859 60.3046V57.1385C77.7859 54.2289 75.6566 51.6313 72.7581 51.3526C69.436 51.0405 66.6378 53.638 66.6378 56.9044V52.6904C66.6378 49.7808 64.5085 47.1832 61.61 46.9045C58.2878 46.5924 55.4896 49.1899 55.4896 52.4563V29.034C55.4896 25.9571 52.9924 23.46 49.9156 23.46C46.8387 23.46 44.3415 25.9571 44.3415 29.034L44.3303 71.2298L44.1854 72.445L43.7283 71.4416L38.9012 58.2534C37.8978 55.5221 35.0105 53.8052 32.19 54.541C28.957 55.3883 27.2291 58.7885 28.3439 61.8542L34.5199 78.5541C35.0551 79.9923 35.3784 81.4973 35.501 83.0246C35.9469 88.8216 38.2546 94.1058 41.822 98.2752L41.8331 98.2975V98.2864C42.4351 98.9887 43.0594 99.6576 43.7283 100.293C48.5332 104.864 55.0214 107.684 62.1785 107.684C76.9498 107.684 88.9341 95.7 88.9341 80.9287V68.0526V60.5499C88.9341 57.6291 86.8048 55.0315 83.9063 54.7528Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4899 29.0339V63.348",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6381 56.9045V65.3994",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7853 60.3039V68.8545",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9059 11.8791L76.9302 1.14542",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9115 1.14539H76.9302V8.16408",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3583 71.1869L1.33398 81.9206M1.33398 81.9206L8.35268 81.9206M1.33398 81.9206L1.33398 74.9019",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_33733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.332,
    height: 110,
    fill: "white",
    transform: "translate(0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.233f7b8fbf909ac7a3f9e46af0561817.svg";
export { ForwardRef as ReactComponent };